import { NotFoundPage } from "pages/NotFoundPage"
import { MCCAccessContactInfoPage } from "pages"
import { createBrowserRouter, createRoutesFromElements, Navigate, Route } from "react-router-dom"
import { BusinessObj, UserMenuItem, AuthenticatedRoot, ProtectedRoute } from "auth"
import { AppRoutes, AppRoute } from "enums/routes"

export class RouteManager {
	constructor(
		private readonly routes: AppRoutes,
		private readonly menuList: UserMenuItem[],
		private readonly businessObjList: BusinessObj[]
	) {}

	GetBusinessObjList(): BusinessObj[] {
		return this.businessObjList
	}

	// checks to see if the route is in the menu list and sets the corresponding business object
	GetRoutes(): AppRoute[] {
		return this.routes
			.Members()
			.Filter((route) => {
				// Check if any menu item's uiPath is a prefix of the route's path
				// OR if the route's path is a prefix of any menu item's uiPath
				return this.menuList.Any(
					(menuItem) =>
						route.Path.HasPrefix(menuItem.screen.uiPath) ||
						menuItem.screen.uiPath.HasPrefix(route.Path)
				)
			})

			.Map((route) => {
				const busObj = this.businessObjList.Find((b) =>
					b.GetBusinessObjType().Tag.Equal(route.BusinessObjType().Tag)
				)
				return busObj.IfSome((obj) => route.SetBuisnessObj(obj)).UnwrapOr(route)
			})
	}

	CreateRouter() {
		return createBrowserRouter(
			createRoutesFromElements(
				<>
					<Route path="/" element={<AuthenticatedRoot />}>
						{this.GetRoutes().Map((route) => {
							const path = route.FullPath
							const isIndex = path.Equal("/")
							/* eslint-disable-next-line*/
							const Comp = route.Data.Component

							return (
								<Route
									key={path}
									index={isIndex || undefined}
									path={isIndex ? undefined : path}
									element={
										<ProtectedRoute>
											<Comp />
										</ProtectedRoute>
									}
								/>
							)
						})}
						<Route path="mcc-access-contact-info" element={<MCCAccessContactInfoPage />} />
						<Route path="notfound" element={<NotFoundPage />} />
						<Route path="*" element={<Navigate to="notfound" />} />
					</Route>
				</>
			)
		)
	}

	GetNavBarRoutes(): AppRoute[] {
		return this.GetRoutes().Filter((route) => !route.Data.hidden)
	}

	GetCurrRoute(p = window.location.pathname): Opt<AppRoute> {
		const exactMatch = this.routes.Members().Find((r) => r.Path.Equal(p))
		if (exactMatch.IsSome()) {
			return exactMatch
		}

		// If no exact match, check if the current pathname is a route with parameters
		// For example, if pathname is "/download/123", it should match a route with path "/download/:id"
		return this.routes.Members().Find((route) => {
			const basePath = route.Path

			// Check if the current pathname starts with the base path
			// This handles cases like "/download/123" matching "/download/:id"
			//
			return p.HasPrefix(basePath) && !basePath.Equal("/")
		})
	}
}
